import { useNavigate, useSearchParams } from 'react-router-dom';
import CustomButton from './CustomButton';
import { ROUTES } from '../helpers/contants';
import {
  addSelectedProductionId,
  getProductionUserDetails,
} from '../redux/commonSlice';
import { deleteMember } from '../redux/locationSlice';
import { RootState, useAppSelector } from '../redux/store';
import ToolTipComponent from './ToolTipComponent';
import { IconButton, Menu, MenuItem } from '@mui/material';
import Images from '../Utils/images';
import React from 'react';
import WarningDialog from './WarningDialog';
import { notify } from '../Utils/toastify';
import { SocketEvents, useSocket } from '../Pages/Chats/SocketContext';

interface Props {
  image?: string;
  heading?: string;
  details?: string | null;
  elevation?: boolean;
  type?: string;
  status?: string;
  buttonText: string;
  id?: any;
  flag?: boolean;
  item?: any;
  ref?: any;
  location?: any;
  locationactive?: any;
  isTotal?: any;
  islocationDashboard?: any;
  isEpisodeDashboard?: any;
  isSetDashboard?: any;
  setName?: any;
  handleDetailRedirection?: any;
  showEditIcon?: boolean;
  onEditClick?: any;
  isDashboardRoute?: boolean;
  dashboardOnClick?: any;
  showLocationCount?: boolean;
  ScheduleTypeDisplay?: any;
  typeDetail?: string;
  moreOptions?: boolean;
  LeaveModal?: any;
  userId?: any;
  memberName?: any;
  isProductionFolder?: any;
  showCopyIcon?: any;

  isEditDisabled?: boolean;
  /** After successful remove-access API (e.g. refresh profile or access list). */
  onRemoveAccessSuccess?: () => void;
}

export default function ProductionCardNew(props: Props) {
  const navigate = useNavigate();
  const { emitEvent } = useSocket();
  const { selectedTalentUser, loading, profileData } = useAppSelector(
    (state: RootState) => state.common,
  );
  const [anchorEl3, setAnchorEl3] = React.useState<null | HTMLElement>(null);
  const [removeAccessOpen, setRemoveAccessOpen] = React.useState(false);
  const removeAccessItemRef = React.useRef<any>(null);

  const handleClickDoc = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl3(event.currentTarget);
  };

  const handleCloseDoc = () => {
    setAnchorEl3(null);
  };
  const [searchParams] = useSearchParams();
  const memberType = searchParams.get('type');
  const {
    image,
    heading,
    locationactive,
    memberName,
    details = '',
    elevation = false,
    type,
    status,
    isTotal,
    buttonText,
    islocationDashboard,
    isEpisodeDashboard,
    id,
    flag,
    setName,
    item,
    ref,
    location,
    LeaveModal,
    isSetDashboard,
    handleDetailRedirection,
    showEditIcon,
    onEditClick,
    isDashboardRoute,
    dashboardOnClick,
    showLocationCount,
    ScheduleTypeDisplay,
    typeDetail,
    moreOptions,
    userId,
    isProductionFolder,
    showCopyIcon,
    isEditDisabled,
    onRemoveAccessSuccess,
  } = props;

  /** Backend member row id for DELETE …/member/:id — v2 associated_entities may use `_id`, `id`, or `memberId`. */
  const getMemberRecordId = (row: any): string | undefined => {
    if (!row || typeof row !== 'object') return undefined;
    const raw =
      row._id ??
      row.id ??
      row.memberId ??
      row.memberShipId ??
      row.membershipId ??
      row.crewMemberId;
    if (raw == null || raw === '') return undefined;
    return String(raw);
  };

  const openRemoveAccessConfirm = (row: any) => {
    handleCloseDoc();
    removeAccessItemRef.current = row;
    setRemoveAccessOpen(true);
  };

  const handleConfirmRemoveAccess = () => {
    const target = removeAccessItemRef.current;
    const memberRecordId = getMemberRecordId(target);
    if (!memberRecordId) {
      notify(
        'Could not remove access: missing membership id on this record.',
        'error',
      );
      setRemoveAccessOpen(false);
      removeAccessItemRef.current = null;
      return;
    }
    const isStudioMemberFlow = memberType != null && memberType !== 'CONTACT';
    deleteMember(
      memberRecordId,
      'CONTACT',
      () => {
        setRemoveAccessOpen(false);
        removeAccessItemRef.current = null;
        emitEvent(SocketEvents.REMOVE_MEMBER, {
          memberId: target.userId,
          entityType: target.entityType,
          entityId: target.entityId,
        });
        onRemoveAccessSuccess?.();
      },
      isStudioMemberFlow,
    );
  };

  const handleClick = () => {
    addSelectedProductionId({ id });
    if (isDashboardRoute && dashboardOnClick) {
      dashboardOnClick();
      return;
    }

    if (!item?.isDefaultRiskCenterUserType) {
      //This is the last breadcrumb so navigate to details page
      navigate(`${ROUTES.LOCATION_DETAIL}/${props.id}`);
      getProductionUserDetails(id, (data: any) => {
        navigate(`/user-detail/${data?.userId}`, {
          state: {
            name: data?.userDetail[0]?.fullName,
            role: data?.roleName,
            productionId: id,
          },
        });
      });
    } else {
      navigate(`${ROUTES.RISK_EVENT_DETAIL}/${props.id}`, {
        state: { name: heading, image: image, description: details },
      });
    }
  };
  const handleLeaveClick = e => {
    // Close the menu
    handleCloseDoc();
    // Then show the leave modal
    if (LeaveModal) {
      LeaveModal();
    }
  };
  const formatNames = (arr: string[] | any) => {
    if (!arr || arr.length === 0) return { text: '', extraCount: 0 };
    if (arr.length <= 2) return { text: arr.join(', '), extraCount: 0 };

    return { text: `${arr[0]}, ${arr[1]}`, extraCount: arr.length - 2 };
  };
  // Function to truncate text
  const truncateText = (text: string, maxLength: number) => {
    return text.length > maxLength
      ? `${text.substring(0, maxLength)}...`
      : text;
  };
  const openMenu = Boolean(anchorEl3);
  const ScheduleDisplay = (scheduleTypes: any[]) => {
    const visibleTypes = scheduleTypes.slice(0, 2);
    const hiddenTypes = scheduleTypes.slice(2); // Only extras
    const hiddenCount = hiddenTypes.length;
    const hiddenTypesText = hiddenTypes
      .map(item => item.scheduleType)
      .join(', ');

    return (
      <div className="types">
        {visibleTypes.map((item, index) => (
          <span className="type no-border" key={index}>
            {item?.scheduleType}
          </span>
        ))}

        {hiddenCount > 0 && (
          <ToolTipComponent title={hiddenTypesText} arrow theme="light">
            <span className="type no-border">+{hiddenCount}</span>
          </ToolTipComponent>
        )}
      </div>
    );
  };

  return (
    <>
      <div className="productionCard" ref={ref}>
        <div
          className={`productionCardInner ${elevation && 'elevation'}`}
          onClick={() =>
            isProductionFolder ? handleDetailRedirection(item) : null
          }
        >
          <figure>
            <img
              src={image}
              alt=""
              onClick={
                flag
                  ? () => handleClick()
                  : () =>
                      isDashboardRoute
                        ? handleClick()
                        : handleDetailRedirection(item)
              }
            />
          </figure>
          <div className="p_card_body">
            <div className="typeNStatus">
              <ToolTipComponent title={heading || ''} theme="light" arrow>
                <h3
                  className=""
                  onClick={
                    flag
                      ? () => handleClick()
                      : () =>
                          isDashboardRoute
                            ? handleClick()
                            : handleDetailRedirection(item)
                  }
                >
                  {heading}
                </h3>
              </ToolTipComponent>

              {showCopyIcon ? (
                <ToolTipComponent title={'Copy Set'} arrow theme="light">
                  <div className="ml-auto">
                    <IconButton
                      className="blank-btn pr0"
                      disabled={isEditDisabled}
                      onClick={() =>
                        navigate(
                          `${ROUTES.CREATE_SET}?id=${item?._id}&name=${item?.productionName}&productionId=${item?.productionId}&setName=${item?.name}&episodeId=${item?.episodeId}&isCopySet=true`,
                        )
                      }
                    >
                      <i className="copy-icon"></i>
                    </IconButton>
                  </div>
                </ToolTipComponent>
              ) : null}

              {status ? (
                <div
                  className={`type white sm`}
                  //   ${
                  //   status?.toLowerCase() === 'active'
                  //     ? ''
                  //     : status?.toLowerCase() === 'inactive'
                  //     ? 'orange'
                  //     : status?.toLowerCase() === 'upcoming'
                  //     ? 'orange' // Apply 'orange' for 'upcoming'
                  //     : 'green'
                  // }
                >
                  {status === 'INACTIVE' ? 'Upcoming' : status}{' '}
                  {/* Display 'Upcoming' instead of 'Inactive' */}
                </div>
              ) : null}

              {typeDetail ? (
                <div className="profile-options">
                  <div className={`type no-border sm`}>{typeDetail}</div>

                  {moreOptions && (item?.canView || !userId) && (
                    <button
                      className="blank-btn pl0 pr0 shrink-0"
                      onClick={handleClickDoc}
                    >
                      <img src={Images.More_Ic} alt="More" />
                    </button>
                  )}
                  <Menu
                    id="basic-menu"
                    anchorEl={anchorEl3}
                    open={openMenu}
                    onClose={handleCloseDoc}
                    MenuListProps={{
                      'aria-labelledby': 'basic-button',
                    }}
                    anchorOrigin={{
                      vertical: 'bottom',
                      horizontal: 'right',
                    }}
                    transformOrigin={{
                      vertical: 'top',
                      horizontal: 'right',
                    }}
                  >
                    {(item?.canView || !userId) && (
                      <MenuItem
                        onClick={() =>
                          navigate(
                            `${ROUTES.VIEW_ACCESS}/${
                              typeDetail == 'Studio' ||
                              item?.accessLevel == 'RESTRICTED'
                                ? item?.entityId
                                : item?.hierarchySource?.entityId ??
                                  item?.entityId
                            }?name=${encodeURIComponent(
                              memberName,
                            )}&userId=${encodeURIComponent(
                              item?.userId,
                            )}&module=${typeDetail}`,
                          )
                        }
                      >
                        View Access
                      </MenuItem>
                    )}
                    {(!userId || userId === profileData?._id) &&
                      item?.canRemove &&
                      !item?.isCreatorAccess && (
                        <MenuItem onClick={handleLeaveClick}>
                          <p style={{ color: 'red' }}>Leave Access</p>
                        </MenuItem>
                      )}

                    {item?.canEdit && userId && userId !== profileData?._id && (
                      <MenuItem
                        onClick={() => {
                          if (item?.entityType === 'studios') {
                            navigate(
                              `${ROUTES.ADD_CONTACT_ROLES_STUDIO}?id=${item?._id}&studioId=${item?.entityId}&type=${memberType}`,
                            );
                          } else if (item?.entityType === 'productions') {
                            navigate(
                              `${ROUTES.ADD_CONTACT_ROLES_PRODUCTION}?id=${item?._id}&productionId=${item?.entityId}&type=${memberType}`,
                            );
                          } else if (item?.entityType === 'episodes') {
                            navigate(
                              `${ROUTES.ADD_CONTACT_ROLES_EPISODE}?id=${item?._id}&episodeId=${item?.entityId}&type=${memberType}`,
                            );
                          } else if (item?.entityType === 'sets') {
                            navigate(
                              `${ROUTES.ADD_CONTACT_ROLES_SET}?id=${item?._id}&setId=${item?.entityId}&type=${memberType}`,
                            );
                          } else if (item?.entityType === 'locations') {
                            navigate(
                              `${ROUTES.ADD_CONTACT_ROLES_LOCATION}?id=${item?._id}&locationId=${item?.entityId}&type=${memberType}`,
                            );
                          } else if (item?.entityType === 'departments') {
                            navigate(
                              `${ROUTES.ADD_CONTACT_ROLES_DEPARTMENT}?id=${item?._id}&departmentId=${item?.entityId}&type=${memberType}`,
                            );
                          }
                        }}
                      >
                        Edit Access
                      </MenuItem>
                    )}

                    {item?.canRemove &&
                    userId &&
                    userId !== profileData?._id ? (
                      <MenuItem onClick={() => openRemoveAccessConfirm(item)}>
                        <p style={{ color: 'red' }}>Remove Access</p>
                      </MenuItem>
                    ) : null}
                  </Menu>
                </div>
              ) : null}
            </div>

            <div className="detail">
              <div>
                {item?.locationCount && !showLocationCount ? (
                  <p className="mb-10">
                    {' '}
                    <i className="pin-icon"></i> {item?.locationCount || 0}{' '}
                    Location
                  </p>
                ) : null}

                {details ? <p className="mb-4">{details}</p> : null}
                {/* {setName ? (
                <p className="mb-4 text-black100 MuiTypography-subtitle1">
                  {setName}
                </p>
              ) : null} */}
                {item?.setNames?.length
                  ? (() => {
                      const { text, extraCount } = formatNames(
                        item?.setNames.map(name => name.toUpperCase()),
                      );
                      return (
                        <>
                          <div className="d-flex align-center">
                            <p className="mb-4 text-black100 MuiTypography-subtitle1">
                              {text}
                            </p>
                            {extraCount > 0 ? (
                              <ToolTipComponent
                                theme="light"
                                title={Object.entries(item?.setNames)
                                  .slice(2)
                                  .map(([_, value]) => `${value.toUpperCase()}`)
                                  .join(', ')}
                              >
                                <span className="MuiTypography-subtitle1 d-inline-block ml-10 nowrap text-primary_blue_500">
                                  +{extraCount}
                                </span>
                              </ToolTipComponent>
                            ) : null}
                          </div>
                        </>
                      );
                    })()
                  : null}
              </div>

              {ScheduleTypeDisplay &&
                ScheduleTypeDisplay?.length &&
                ScheduleDisplay(ScheduleTypeDisplay)}

              {location &&
              typeof location === 'object' &&
              !Array.isArray(location) ? (
                <>
                  <div className="type-row mb-4">
                    {Object.entries(location)
                      .slice(0, 2) // Show only the first 2 locations
                      .map(([key, value]) => (
                        <div className="type" key={key}>
                          {key}: {value}
                        </div>
                      ))}
                    {Object.keys(location).length > 2 && (
                      <div className="text-primary_blue_500 cursor type">
                        <ToolTipComponent
                          theme="light"
                          title={Object.entries(location)
                            .slice(2) // Get all remaining key-value pairs
                            .map(([key, value]) => `${key}: ${value}`)
                            .join(', ')}
                        >
                          {/* <div className="type"> */}+
                          {Object.keys(location).length - 2}
                        </ToolTipComponent>
                        {/* </div> */}
                      </div>
                    )}
                  </div>
                </>
              ) : null}
              {locationactive && typeof locationactive === 'object' ? (
                <>
                  <div className="type-row mb-4">
                    {Array.isArray(locationactive) ? (
                      <>
                        {locationactive.slice(0, 2).map((loc, index) => (
                          <div className="type" key={index}>
                            {loc}
                          </div>
                        ))}
                        {locationactive.length > 2 && (
                          <div className="text-primary_blue_500 cursor">
                            +{' '}
                            <ToolTipComponent
                              theme="light"
                              title={locationactive.slice(2).join(', ')}
                            >
                              {locationactive.length - 2}
                            </ToolTipComponent>
                          </div>
                        )}
                      </>
                    ) : (
                      <>
                        {Object.entries(locationactive)
                          .slice(0, 2)
                          .map(([key, value]) => (
                            <div className="type" key={key}>
                              {key}: {value}
                            </div>
                          ))}
                        {Object.keys(locationactive).length > 2 && (
                          <div className="text-primary_blue_500 cursor">
                            +{' '}
                            <ToolTipComponent
                              theme="light"
                              title={Object.entries(locationactive)
                                .slice(2)
                                .map(([key, value]) => `${key}: ${value}`)
                                .join(', ')}
                            >
                              {Object.keys(locationactive).length - 2}
                            </ToolTipComponent>
                          </div>
                        )}
                      </>
                    )}
                  </div>
                </>
              ) : null}
              {type &&
              type === 'Episode' &&
              item?.productionSchedule?.length ? (
                <>
                  <div className="type-row mb-4">
                    {item?.productionSchedule
                      ?.slice(0, 2) // Show only the first 2 locations
                      .map((item: any, index: number) => (
                        <div className="type" key={index}>
                          {item?.scheduleType}
                        </div>
                      ))}
                    {item?.productionSchedule?.length > 2 && (
                      <div className="text-primary_blue_500 cursor">
                        {/* <div className="type"> */}+{' '}
                        <ToolTipComponent
                          theme="light"
                          title={item?.productionSchedule
                            ?.slice(2) // Get all remaining key-value pairs
                            .map((item: any) => `${item?.scheduleType}`)
                            .join(', ')}
                        >
                          {item?.productionSchedule?.length - 2}
                        </ToolTipComponent>
                        {/* </div> */}
                      </div>
                    )}
                  </div>
                </>
              ) : null}
            </div>

            <div className="card-btns">
              {buttonText ? (
                <div>
                  <CustomButton
                    id=""
                    variant="contained"
                    width="100%"
                    onClick={() => {
                      if (handleDetailRedirection) {
                        handleDetailRedirection(item);
                      } else if (flag) {
                        handleClick();
                      } else {
                        handleClick();
                      }
                      // else if (islocationDashboard) {
                      //   navigate(`${ROUTES.LOCATION_DETAIL}/${props.id}`)
                      // } else if (isEpisodeDashboard) {
                      //   navigate(`${ROUTES.EPISODE_DETAIL}/${props.id}`)
                      // } else if (isSetDashboard) {
                      //   navigate(`${ROUTES.SET_DETAIL}/${props.id}`)
                      // } else {
                      //   navigate(`${ROUTES.PRODUCTION_DETAIL}/${props.id}`)
                      // }
                    }}
                    text={buttonText}
                    showIcon={false}
                    // loading={loading}
                  />
                </div>
              ) : null}
              {showEditIcon ? (
                <div className="edit-div">
                  <IconButton onClick={onEditClick} disabled={isEditDisabled}>
                    <i className="edit-grey-icon"></i>
                  </IconButton>
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </div>
      <WarningDialog
        open={removeAccessOpen}
        title="Remove access?"
        description="Are you sure you want to remove this access? This cannot be undone."
        type="warning"
        handleClose={() => {
          setRemoveAccessOpen(false);
          removeAccessItemRef.current = null;
        }}
        onClick={handleConfirmRemoveAccess}
        cancelBtnText="Cancel"
        confirmBtnText="Yes, remove"
        showIcon={false}
      />
    </>
  );
}
